import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Building2 } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;
export const companyLogoSrc = (url) => (url?.startsWith('/api/') ? `${API}${url}` : url || '');

const cached = () => { try { return JSON.parse(localStorage.getItem('company_data') || '{}'); } catch { return {}; } };

// Sidebar brand: always refreshed from the DB so name/logo edits show everywhere.
export const CompanyBrand = () => {
  const [c, setC] = useState(cached);
  const [broken, setBroken] = useState(false);
  useEffect(() => {
    const token = localStorage.getItem('company_token');
    if (!token) return;
    const sync = () => axios.get(`${API}/api/company/profile`, { headers: { Authorization: `Bearer ${token}` } })
      .then(({ data }) => {
        const next = { ...cached(), company_name: data.company_name, logo_url: data.logo_url || '' };
        localStorage.setItem('company_data', JSON.stringify(next));
        setC(next); setBroken(false);
      }).catch(() => {});
    sync();
    window.addEventListener('company-profile-updated', sync);
    return () => window.removeEventListener('company-profile-updated', sync);
  }, []);
  const logo = companyLogoSrc(c.logo_url);
  return (
    <>
      {logo && !broken ? (
        <img src={logo} alt={`${c.company_name || 'Company'} logo`} onError={() => setBroken(true)}
          className="w-9 h-9 rounded-lg object-contain border border-gray-200 bg-white shrink-0" data-testid="company-brand-logo" />
      ) : (
        <div className="w-9 h-9 bg-[#0a66c2] rounded-lg flex items-center justify-center shrink-0"><Building2 className="text-white" size={18} /></div>
      )}
      <span className="font-semibold text-[#191919] text-sm truncate max-w-[140px]" data-testid="company-brand-name">{c.company_name || 'Company'}</span>
    </>
  );
};
